import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { MaterialIssuePopup } from './MaterialIssueTable';
import { decryptAES } from '../../../utils/Encryption';
import moment from 'moment';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import IssuePopup from './IssuePopup';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class MaterialIssue extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        //this.otherFormsServices = new OtherFormsServices();
        this.transactionStockServices = new TransactionStockServices();
        this.masterEntryServices = new MasterEntryServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            globalUserID: '',
            usp_Users: [],
            isModalOpen: false,
            isSaving: false,
            isIssueOpen: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            itemRowData: [],
            itemColDefs: [],
            selectedRowsForMaterialIssue: [],
            selectedRowsForMaterialIssueItems: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            // isStoreToPlantDetails: false,
            materialObject: {
                idMaterialIssue: 0,
                idMaterialProduction: 0,
                updateStatus: 0,
                issueNo: '',
                prefix: '',
                issueDate: moment(new Date().toISOString()).format('YYYY-MM-DD'),
                idEmployee: 0,
                EmployeeList: [],
                idPlant: 0,
                plantList: [],
                idIssue: 1,
                issueList: [
                    { value: 1, label: 'FROM PRODUCTION' },
                    // { value: 2, label: 'FROM REWORK' },
                ],
                reworkNo: '',
                //prefix: '',
                addproductionList: [],
                subItemList: [],
                storeToPlantList: [],
                e_Date: '',
                idItem: 0,
                itemName: '',
                totalProductionQty: 0,
                woRecvNo: '',

                storeToPlantQty: 0,
                storeToPlantItemName: '',
                transferNo: '',
                idTransferLocation: 0
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForPurchase: {
                idWorkOrder: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "work order"
                        ),
                    },
                ],
            },
            validationRulesForItem: {
                idItem: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "item"
                        ),
                    },
                ],
            },
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetDetailsFields();
        this.setState({ isModalOpen: true }, () => {
            this.getPrefixSelectPrefix();
        })
    };

    handleCellClick = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idMaterialIssue);
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.usp_Transaction_MaterialIssueSelectbyId(event.data.idMaterialIssue);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState, storeToPlantList: []
        });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForRegister = () => {
        const newValidState = isValidForm(
            this.state.registerObject,
            this.state.validationRulesForPurchase,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFieldsForItem = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRulesForItem,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    setIssueModel = () => {
        this.setState({ isIssueOpen: !this.state.isIssueOpen });
    };
    issueModel = () => {
        this.setState({ isIssueOpen: true });
    };
    exitPopup = () => {
        this.setState({ isIssueOpen: false, });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleCellClickItemList2 = (event) => {
        this.usp_Transaction_MaterialProductionSelectByIDNotInMaterialIssueItems(event.data.idMaterialProduction);
    };

    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.materialObject;
        details[name] = value;
        this.setState({ materialObject: details });
    }

    handleChangeForDropdown = (event, name, field) => {
        let details = this.state.materialObject;
        let details1 = this.state.itemObject
        let value = event.value;
        if (field === 'materialObject') {
            details[name] = value;
            this.setState({ materialObject: details });
        } else {
            details1[name] = value;
            this.setState({ itemObject: details });
        }
    }

    resetDetailsFields = () => {
        let materialObject = this.state.materialObject;
        materialObject.idMaterialIssue = 0;
        materialObject.idMaterialProduction = 0;
        materialObject.updateStatus = 0;
        materialObject.issueNo = '';
        //materialObject.prefix = '';
        materialObject.issueDate = moment(new Date().toISOString()).format('YYYY-MM-DD');
        materialObject.idEmployee = 0;
        // materialObject.EmployeeList: [],
        materialObject.idPlant = 0;
        // materialObject.plantList: [],
        // materialObject.issueList: [
        //     { value: 1, label: 'FROM PRODUCTION' },
        //     { value: 2, label: 'FROM REWORK' },
        // ],
        materialObject.reworkNo = '';
        //materialObject.prefix = '';
        materialObject.addproductionList = [];
        materialObject.subItemList = [];
        materialObject.e_Date = '';
        materialObject.idItem = 0
        materialObject.itemName = ''
        materialObject.totalProductionQty = 0

        materialObject.storeToPlantQty = 0
        materialObject.storeToPlantItemName = ''
        materialObject.transferNo = ''
        materialObject.idTransferLocation = 0
        // remove validation messages
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState, materialObject: materialObject, itemRowData: [], storeToPlantList: []
        });
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name, companyName: prop.companyName, globalUserID: prop.globalUserID }, () => {
                this.procSelectAllRecordsSP();
                this.getPlantList();
                this.getMaster_ItemSelectbyItemType('RAW MATERIAL');
                this.usp_GetAllUsers();
            });
        }
    }

    usp_GetAllUsers = () => {
        this.accountTransactionServices.usp_GetAllUsers().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    this.setState({
                        usp_Users: data,
                    });
                }
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Material Issue",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            width: this.getPinnedColumnWidth(key) !== undefined ? this.getPinnedColumnWidth(key) : window.innerWidth * 0.05,
                            //pinned: ["sR.No", "jobWorkNo", "jobWorkInwardDate", "jobWorkFrom", "invoiceNo"].includes(key) ? "left" : undefined,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idMaterialIssue", "sR.No"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Material Issue",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id);
                            this.getPrefixSelectPrefix();
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                        this.getPrefixSelectPrefix();
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "issueNo": window.innerWidth * 0.02,
            "issueDate": window.innerWidth * 0.04,
            "drawingNo": window.innerWidth * 0.11,
            "itemName": window.innerWidth * 0.25,
            "qty": window.innerWidth * 0.06,
            "status": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }
    getPinnedColumnWidth = (key) => {
        const colwidth = {
            // "sR.No": window.innerWidth * 0.05,
            // "jobWorkNo": window.innerWidth * 0.09,
            // "jobWorkInwardDate": window.innerWidth * 0.08,
            // "jobWorkFrom": window.innerWidth * 0.08,
            // "invoiceNo": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id) => {
        let request = {
            id: id,
            formname: "Material Issue",
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }

    getColumnWidth2 = (key) => {
        const colwidth = {
            // "drawingNo": window.innerWidth * 0.11,
            // "itemCategory": window.innerWidth * 0.16,
            // "itemName": window.innerWidth * 0.2,
            // "hsnCode": window.innerWidth * 0.06,
            // "quantity": window.innerWidth * 0.06,
            // "rate": window.innerWidth * 0.06,
            // "taxableAmt": window.innerWidth * 0.06,
            // "sgst": window.innerWidth * 0.04,
            // "sgstAmt": window.innerWidth * 0.06,
            // "cgst": window.innerWidth * 0.04,
            // "cgstAmt": window.innerWidth * 0.06,
            // "igst": window.innerWidth * 0.04,
            // "igstAmt": window.innerWidth * 0.06,
            // "netTotal": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }

    getPlantList = () => {
        this.transactionStockServices.usp_Master_PlantSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    data = data.map((x) => ({
                        value: x.idPlant,
                        label: x.plantDetails,
                    }));
                }
                let materialObject = this.state.materialObject;
                //transferObject.locationList = data;
                materialObject.plantList = data;
                this.setState({ materialObject: materialObject }, () => {
                });
            }
        });
    }

    getPrefixSelectPrefix = () => {
        let request = {
            formname: "FrmTransactionMaterialIssue",
            idCompany: this.state.idCompany,
            idCompanyDivision: 0,
        };
        this.accountTransactionServices.getPrefixSelectPrefix(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0];
                let dt = this.state.materialObject;
                if (data) {
                    dt.prefix = data.prefix;
                }
                this.setState({ materialObject: dt }, () => {
                    this.getInwardNoCount();
                });
            } else {
                this.getInwardNoCount();
            }
        });
    }

    getInwardNoCount = () => {
        // this.accountTransactionServices.getInwardNoCount(request).then((response) => {
        //     if (response.statusCode == 200 && response.responseItem !== null) {
        //         let data = response.responseItem.responseContent;
        //debugger;
        let details = this.state.materialObject;
        let maxIdPaymentMake = this.state.rowData.length > 0
            ? Math.max(...this.state.rowData.map(item => item.idMaterialIssue))
            : 0;
        let inwardNo = String(maxIdPaymentMake + 1).padStart(3, '0');
        details.issueNo = details.prefix + inwardNo;
        this.setState({ materialObject: details }, () => {
            //this.getNetworkConfiguration();
        })
        //     }
        // });
    }

    getMaster_ItemSelectbyItemType = (label) => {
        let request = [label, this.state.idCompany];
        this.masterEntryServices.getMaster_ItemSelectbyItemType(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let itemObject = this.state.materialObject;
                itemObject.itemList = data;
                itemObject.itemId = "";
                // data = data.map((x) => ({
                //     value: x.idItem,
                //     label: x.itemCategory + ' - ' + x.itemName + ' - ' + x.drawingNo + ' - ' + x.searchText,
                // }));

                // if (name === 'itemTypeId2') {
                //     itemObject.itemList2 = data;
                //     itemObject.itemId2 = "";
                // } else if (name === 'itemTypeId') {
                // itemObject.itemList = data;
                // itemObject.itemId = "";
                // }
                this.setState({
                    materialObject: itemObject,
                });
            }
        });
    }

    addproduction = () => {
        let request = [this.state.materialObject.updateStatus, this.state.materialObject.idMaterialIssue, this.state.idCompany];
        this.transactionStockServices.usp_Transaction_MaterialProductionSelectNotinMaterialIssue(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let itemObject = this.state.materialObject;
                itemObject.addproductionList = [];
                if (data.length > 0) {
                    itemObject.addproductionList = data;
                    data.map((x, key) => {
                        x.isSelected = false;
                        // if (key === 0) {
                        //     x.isSelected = true;
                        // }
                    })
                }
                this.setState({
                    materialObject: itemObject,
                    isIssueOpen: true
                }, () => {
                    if (this.state.materialObject.addproductionList.length > 0) {
                        let id = this.state.materialObject.addproductionList[0].idMaterialProduction;
                        this.usp_Transaction_MaterialProductionSelectByIDNotInMaterialIssueItems(id);
                    }
                });
            }
        });
    }

    usp_Transaction_MaterialProductionSelectByIDNotInMaterialIssueItems = (id) => {
        let request = [id, this.state.materialObject.idMaterialIssue, this.state.materialObject.updateStatus];
        this.transactionStockServices.usp_Transaction_MaterialProductionSelectByIDNotInMaterialIssueItems(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let itemObject = this.state.materialObject;
                //if (data.length > 0) {
                // data.map((x) => {
                //     x.isSelected = false;
                // })
                //}
                itemObject.subItemList = data;
                this.setState({
                    materialObject: itemObject,
                }, () => {
                    //thi
                });
            }
        });
    }

    getStoreToPlantData = () => {
        let itemId = this.state.materialObject.idItem
        let request = [itemId, this.state.materialObject.idMaterialIssue, this.state.materialObject.updateStatus, this.state.idCompany];
        // if (!this.state.isStoreToPlantDetails) {
        this.transactionStockServices.usp_Transaction_StoreToPlantDataSelectByItemId(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let itemObject = this.state.materialObject;
                itemObject.storeToPlantList = data;
                this.setState({
                    materialObject: itemObject,
                });
            } else {
            }
        });
        // }
        // this.setState({
        //     isStoreToPlantDetails: !this.state.isStoreToPlantDetails,
        // });
    }

    // addMrsData = () => {
    //     let itemRowData = [];
    //     this.state.materialObject.addproductionList.map((x) => {
    //         if (x.isSelected) {
    //             let request = [x.idMaterialProduction, this.state.materialObject.idMaterialIssue, this.state.materialObject.updateStatus];
    //             this.transactionStockServices.usp_Transaction_MaterialProductionSelectByIDNotInMaterialIssueItems(request).then((response) => {
    //                 if (response.statusCode === 200 && response.responseItem !== null) {
    //                     let data = response.responseItem.responseContent;
    //                     //let itemObject = this.state.;
    //                     itemRowData.push({ ...data });
    //                     // this.setState({
    //                     //     materialObject: itemObject,
    //                     // }, () => {
    //                     //     thi
    //                     // });
    //                 }
    //             });
    //         }
    //     });
    //     this.setState({ itemRowData: itemRowData });
    // }

    addMrsData = async () => {
        // try {
        //     const itemRowData = [];
        //     for (const x of this.state.selectedRowsForMaterialIssueItems) {
        //         const request = [
        //             x.idMaterialProduction,
        //             this.state.materialObject.idMaterialIssue,
        //             this.state.materialObject.updateStatus
        //         ];

        //         const response = await this.transactionStockServices.usp_Transaction_MaterialProductionSelectByIDNotInMaterialIssueItems(request);

        //         if (response.statusCode === 200 && response.responseItem !== null) {
        //             const data = response.responseItem.responseContent;
        //             itemRowData.push(...data);
        //         }
        //     }
        //     this.setState({ itemRowData });

        // } catch (error) {
        //     console.error("Error while adding MRS data:", error);
        // }
        let issueRowData = this.state.selectedRowsForMaterialIssue;
        if (this.state.selectedRowsForMaterialIssueItems.length > 0) {

            const firstIdItem = issueRowData[0];
            const allSameIdItem = issueRowData.every(row => (row.idItem === firstIdItem?.idItem));
            const totalQty = issueRowData.reduce((sum, row) => sum + (row.productionQuantity || 0), 0);
            let materialObject = this.state.materialObject;
            materialObject.idItem = firstIdItem?.idItem || 0;
            materialObject.itemName = firstIdItem?.itemName || '';
            materialObject.woRecvNo = firstIdItem?.woRecvNo || '';
            materialObject.totalProductionQty = totalQty;
            this.setState({ materialObject: materialObject })

            if (!allSameIdItem) {
                this.SwalServices.Alert('You have selected multiple different items. Please select records for only one item at a time.');
                return;
            }

            this.setState({ itemRowData: this.state.selectedRowsForMaterialIssueItems }, () => {
                this.setState({ isIssueOpen: false })
                this.getStoreToPlantData()
            })
        } else {
            this.SwalServices.Alert('Please Select Item')
        }
    };

    onSelectionChanged = (selectedRows) => {
        this.setState({ selectedRowsForMaterialIssue: selectedRows }, async () => {
            const requests = selectedRows.map(element => {
                return this.usp_Transaction_MaterialProductionSelectByIDNotInMaterialIssueItemsForSelection(element.idMaterialProduction);
            });

            const results = await Promise.all(requests);

            const mergedData = results.flat();
            let array = this.state.materialObject
            array.subItemList = mergedData
            this.setState({ materialObject: array });
        });
    }

    usp_Transaction_MaterialProductionSelectByIDNotInMaterialIssueItemsForSelection = (id) => {
        return new Promise((resolve) => {
            if (id > 0) {
                let request = [id, this.state.materialObject.idMaterialIssue, this.state.materialObject.updateStatus];
                this.transactionStockServices.usp_Transaction_MaterialProductionSelectByIDNotInMaterialIssueItems(request)
                    .then((response) => {
                        if (response.statusCode == 200 && response.responseItem !== null) {
                            let res = response.responseItem.responseContent;
                            if (res && res.length > 0) {
                                resolve(res); // Return the array
                            } else {
                                resolve([]); // Return empty array if no data
                            }
                        } else {
                            resolve([]); // Return empty array on error
                        }
                    });
            } else {
                resolve([]); // Invalid idPurchaseOrder
            }
        });
    };

    onSelectionItemsChanged = (selectedRows) => {
        this.setState({ selectedRowsForMaterialIssueItems: selectedRows })
    }

    submit = () => {
        // guard against double-submit (rapid double-click / impatient re-click while the save is in flight)
        if (this.isSubmitting) {
            return;
        }
        if (this.state.itemRowData.length === 0) {
            this.SwalServices.Error("Please add item details.");
            return;
        }
        if (this.state.materialObject.storeToPlantQty > 0) {
            if (this.state.materialObject.storeToPlantQty !== this.state.materialObject.totalProductionQty) {
                this.SwalServices.Error("The total Store to Plant quantity must be equal to the total production quantity.");
                return;
            }
        }
        if (this.state.materialObject.storeToPlantList.length > 0 && this.state.materialObject.storeToPlantQty === 0 && this.state.materialObject.updateStatus === 0) {
            this.SwalServices.Error("Please select Store to Plant details.");
            return;
        }
        let details = this.state.materialObject;

        let requestData = {
            idMaterialIssue: details.idMaterialIssue,
            issueNo: details.issueNo,
            issueDate: details.issueDate,
            issueFrom: details.issueList.find(x => x.value === details.idIssue)?.label || '', //details.idIssue, // required
            authEmployee: details.idEmployee,
            idPlant: details.idPlant, // required
            e_Date: details.e_Date ? details.e_Date : new Date().toISOString(),
            e_IDUser: this.state.idUser,
            isUpdated: details.updateStatus > 0 ? true : false,
            updatedDate: details.updateStatus > 0 ? new Date().toISOString() : null,
            u_IDUser: details.updateStatus > 0 ? this.state.idUser : 0,
            isDeleted: false,
            deletedDate: null,
            d_IDUser: 0,
            idCompany: this.state.idCompany,
            prefix: details.prefix,
            idRework: details.reworkNo,
            idFinancialYear: null,
            itemList: [],
            idItem: details.idItem,
            totalProductionQty: details.totalProductionQty,
            woRecvNo: details.woRecvNo,


            storeToPlantQty: details.storeToPlantQty,
            storeToPlantItemName: details.storeToPlantItemName,
            transferNo: details.transferNo,
            idTransferLocation: details.idTransferLocation
            // idTransferLocation: details.idTransferLocation,
            // updateStatus: details.updateStatus,
            // date: details.date,
            // type: details.fromList.find(x => x.value === details.idFrom)?.label || '',
            // idItem: details.idItem,
            // quantity: details.quantity,
            // idPlantLocation: details.idLocation,
            // idPlantLocationToTransfer: details.idTransfer,
            // referenceNo: details.refNo,
            // referenceDate: details.refDate,
            // remarks: details.remarks,
            // isUpdated: 1,
            // updatedDate: new Date().toISOString(),
            // u_IdUser: this.state.idUser,
            // idCompany: this.state.idCompany,
            // e_Date: new Date().toISOString(),
            // e_IdUser: this.state.idUser,
            // itemList: [],
            // deleteItemsList: details.deleteItemsList,
        };

        // this.state.itemRowData?.map((x) => {
        //     x.idItem = x.idItemName;
        //     x.itemRemarks = x.remarks;
        // });
        let requestItemRowData = [];
        let itemRowData = this.state.itemRowData;

        // itemRowData?.map((x) => {
        //     requestItemRowData.push({
        //         idMaterialIssue: x.idMaterialIssue,
        //         drawingNo: x.drawingNo,
        //         itemType: x.itemType,
        //         idItem: x.idItem,
        //         quantity: x.quantity,
        //         idIndentRegisterItems: x.idIndentRegisterItems,
        //         idIndentRegister: x.idIndentRegister,
        //         itemRemarks: x.itemRemarks,
        //         idMaterialIssueItems: x.idMaterialIssueItems,
        //         idMaterialProduction: x.idMaterialProduction,
        //         idMaterialProductionItems: x.idMaterialProductionItems,
        //         utStatus: x.utStatus,
        //         idWOOrderRecv: x.idWOOrderRecv
        //     });
        // });
        requestData.itemList = itemRowData; //requestItemRowData;

        this.isSubmitting = true;
        this.setState({ isSaving: true });
        this.transactionStockServices.usp_Transaction_MaterialIssueInsertUpdate(requestData)
            .then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent;
                    if (dynamicData?.errorType === "Exists") {
                        this.SwalServices.Warning(dynamicData.errorMessage);
                    } else {
                        if (dynamicData.isExist === true) {
                            this.SwalServices.Warning("The issue process transaction has already processed completed for this issue number.");
                        } else {
                            if (details.updateStatus === 1) {
                                this.SwalServices.Success("Updated successfully.");
                            } else {
                                this.SwalServices.Success("Saved successfully.");
                            }
                        }
                        this.resetDetailsFields();
                        //this.resetItemDetails();
                        //this.resetWorkObjectDetails();
                        //this.resetWorkPlanningObject();
                        this.setState({ isModalOpen: false }, () => {
                            this.procSelectAllRecordsSP();
                        });
                    }
                } else {
                    this.setState({ isModalOpen: false }, () => {
                        this.SwalServices.Error(response.message);
                        this.procSelectAllRecordsSP();
                    });
                }
            })
            .catch((err) => {
                this.SwalServices.Error("Something went wrong: " + err.message);
            })
            .finally(() => {
                this.isSubmitting = false;
                this.setState({ isSaving: false });
            });
    };

    usp_Transaction_MaterialIssueSelectbyId = (id) => {
        this.transactionStockServices.usp_Transaction_MaterialIssueSelectbyId(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res1 = response.responseItem.responseContent[0][0];
                let res2 = response.responseItem.responseContent[1];

                let materialObject = this.state.materialObject;
                materialObject.idMaterialIssue = res1.idMaterialIssue;
                materialObject.idMaterialProduction = res1.idMaterialProduction || 0;
                materialObject.updateStatus = 1;
                materialObject.prefix = res1.prefix || materialObject.prefix;
                materialObject.issueNo = materialObject.prefix + res1.issueNo;
                materialObject.issueDate = moment(res1.issueDate).format('YYYY-MM-DD');
                materialObject.idEmployee = res1.authEmployee;
                // materialObject.EmployeeList: [],
                materialObject.idPlant = res1.idPlant;
                // materialObject.plantList: [],
                materialObject.idIssue = materialObject.issueList.find(x => x.label === res1.issueFrom)?.value || 0; //res1.idIssue;
                //issueFrom: materialObject.issueList.find(x => x.value === details.idIssue)?.label || '', 
                // materialObject.issueList: [
                //     { value: 1, label: 'FROM PRODUCTION' },
                //     { value: 2, label: 'FROM REWORK' },
                // ],
                materialObject.reworkNo = res1.idRework;
                //materialObject.prefix = res1.prefix;
                materialObject.addproductionList = [];
                materialObject.subItemList = [];
                materialObject.e_Date = res1.e_Date ? moment(res1.e_Date).format('YYYY-MM-DD') : '';
                materialObject.idItem = res1.idItem || 0
                materialObject.itemName = res1.itemName || ''
                materialObject.totalProductionQty = res1.totalProductionQty || 0
                materialObject.woRecvNo = res1.woRecvNo || 0

                materialObject.storeToPlantQty = res1.storeToPlantQty
                materialObject.storeToPlantItemName = res1.storeToPlantItemName
                materialObject.transferNo = res1.transferNo
                materialObject.idTransferLocation = res1.idTransferLocation
                // if (res2.length > 0) {
                //     res2.map((x) => {
                //         x.isSelected = false;
                //     })
                // }
                //itemObject.subItemList = data;
                this.setState({
                    materialObject: materialObject, itemRowData: res2, isModalOpen: true, globalUserID: res1.modifiedBy
                }, () => {
                    //thi
                });
            }
        });
    }

    getStoreToPlantSelectedRow = (selectedRow) => {
        let details = this.state.materialObject
        details.storeToPlantQty = selectedRow.data.quantity
        details.storeToPlantItemName = selectedRow.data.itemName
        details.transferNo = selectedRow.data.transferNo
        details.idTransferLocation = selectedRow.data.idTransferLocation
        this.setState({ materialObject: details })
    }

    render() {
        return (
            <div className='purchase-inquiry'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <MaterialIssuePopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            materialObject={this.state.materialObject}
                            itemObject={this.state.itemObject}
                            handleChange={this.handleChange.bind(this)}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                            onGridReady={this.onGridReady.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            isSaving={this.state.isSaving}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            itemColDefs={this.state.itemColDefs}
                            addproduction={this.addproduction.bind(this)}
                            issueModel={this.issueModel.bind(this)}
                            getStoreToPlantData={this.getStoreToPlantData.bind(this)}
                            // isStoreToPlantDetails={this.state.isStoreToPlantDetails}
                            getStoreToPlantSelectedRow={this.getStoreToPlantSelectedRow.bind(this)}
                            usp_Users={this.state.usp_Users}
                            globalUserID={this.state.globalUserID}
                        />
                        <IssuePopup
                            isIssueOpen={this.state.isIssueOpen}
                            setIssueModel={this.setIssueModel.bind(this)}
                            addMrsData={this.addMrsData.bind(this)}
                            exit={this.exitPopup.bind(this)}
                            handleCellClickItemList2={this.handleCellClickItemList2.bind(this)}
                            issueRowData={this.state.materialObject.addproductionList}
                            issueRowData2={this.state.materialObject.subItemList}
                            onSelectionChanged={this.onSelectionChanged.bind(this)}
                            onSelectionItemsChanged={this.onSelectionItemsChanged.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Material issue</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    onCellClicked={this.handleCellClick}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
